'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var convert = require('../converter');

var tools_1 = require('../converter/tools');

var varuint = require('../converter/varint');

var typeFields_1 = require('../typeFields');

function psbtFromBuffer(buffer, txGetter) {
  var offset = 0;

  function varSlice() {
    var keyLen = varuint.decode(buffer, offset);
    offset += varuint.encodingLength(keyLen);
    var key = buffer.slice(offset, offset + keyLen);
    offset += keyLen;
    return key;
  }

  function readUInt32BE() {
    var num = buffer.readUInt32BE(offset);
    offset += 4;
    return num;
  }

  function readUInt8() {
    var num = buffer.readUInt8(offset);
    offset += 1;
    return num;
  }

  function getKeyValue() {
    var key = varSlice();
    var value = varSlice();
    return {
      key: key,
      value: value
    };
  }

  function checkEndOfKeyValPairs() {
    if (offset >= buffer.length) {
      throw new Error('Format Error: Unexpected End of PSBT');
    }

    var isEnd = buffer.readUInt8(offset) === 0;

    if (isEnd) {
      offset++;
    }

    return isEnd;
  }

  if (readUInt32BE() !== 0x70736274) {
    throw new Error('Format Error: Invalid Magic Number');
  }

  if (readUInt8() !== 0xff) {
    throw new Error('Format Error: Magic Number must be followed by 0xff separator');
  }

  var globalMapKeyVals = [];
  var globalKeyIndex = {};

  while (!checkEndOfKeyValPairs()) {
    var keyVal = getKeyValue();
    var hexKey = keyVal.key.toString('hex');

    if (globalKeyIndex[hexKey]) {
      throw new Error('Format Error: Keys must be unique for global keymap: key ' + hexKey);
    }

    globalKeyIndex[hexKey] = 1;
    globalMapKeyVals.push(keyVal);
  }

  var unsignedTxMaps = globalMapKeyVals.filter(function (keyVal) {
    return keyVal.key[0] === typeFields_1.GlobalTypes.UNSIGNED_TX;
  });

  if (unsignedTxMaps.length !== 1) {
    throw new Error('Format Error: Only one UNSIGNED_TX allowed');
  }

  var unsignedTx = txGetter(unsignedTxMaps[0].value); // Get input and output counts to loop the respective fields

  var _unsignedTx$getInputO = unsignedTx.getInputOutputCounts(),
      inputCount = _unsignedTx$getInputO.inputCount,
      outputCount = _unsignedTx$getInputO.outputCount;

  var inputKeyVals = [];
  var outputKeyVals = []; // Get input fields

  var _iterator = _createForOfIteratorHelper(tools_1.range(inputCount)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var index = _step.value;
      var inputKeyIndex = {};
      var input = [];

      while (!checkEndOfKeyValPairs()) {
        var _keyVal = getKeyValue();

        var _hexKey = _keyVal.key.toString('hex');

        if (inputKeyIndex[_hexKey]) {
          throw new Error('Format Error: Keys must be unique for each input: ' + 'input index ' + index + ' key ' + _hexKey);
        }

        inputKeyIndex[_hexKey] = 1;
        input.push(_keyVal);
      }

      inputKeyVals.push(input);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(tools_1.range(outputCount)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _index = _step2.value;
      var outputKeyIndex = {};
      var output = [];

      while (!checkEndOfKeyValPairs()) {
        var _keyVal2 = getKeyValue();

        var _hexKey2 = _keyVal2.key.toString('hex');

        if (outputKeyIndex[_hexKey2]) {
          throw new Error('Format Error: Keys must be unique for each output: ' + 'output index ' + _index + ' key ' + _hexKey2);
        }

        outputKeyIndex[_hexKey2] = 1;
        output.push(_keyVal2);
      }

      outputKeyVals.push(output);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return psbtFromKeyVals(unsignedTx, {
    globalMapKeyVals: globalMapKeyVals,
    inputKeyVals: inputKeyVals,
    outputKeyVals: outputKeyVals
  });
}

exports.psbtFromBuffer = psbtFromBuffer;

function checkKeyBuffer(type, keyBuf, keyNum) {
  if (!keyBuf.equals(Buffer.from([keyNum]))) {
    throw new Error("Format Error: Invalid ".concat(type, " key: ").concat(keyBuf.toString('hex')));
  }
}

exports.checkKeyBuffer = checkKeyBuffer;

function psbtFromKeyVals(unsignedTx, _ref) {
  var globalMapKeyVals = _ref.globalMapKeyVals,
      inputKeyVals = _ref.inputKeyVals,
      outputKeyVals = _ref.outputKeyVals;
  // That was easy :-)
  var globalMap = {
    unsignedTx: unsignedTx
  };
  var txCount = 0;

  var _iterator3 = _createForOfIteratorHelper(globalMapKeyVals),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var keyVal = _step3.value;

      // If a globalMap item needs pubkey, uncomment
      // const pubkey = convert.globals.checkPubkey(keyVal);
      switch (keyVal.key[0]) {
        case typeFields_1.GlobalTypes.UNSIGNED_TX:
          checkKeyBuffer('global', keyVal.key, typeFields_1.GlobalTypes.UNSIGNED_TX);

          if (txCount > 0) {
            throw new Error('Format Error: GlobalMap has multiple UNSIGNED_TX');
          }

          txCount++;
          break;

        case typeFields_1.GlobalTypes.GLOBAL_XPUB:
          if (globalMap.globalXpub === undefined) {
            globalMap.globalXpub = [];
          }

          globalMap.globalXpub.push(convert.globals.globalXpub.decode(keyVal));
          break;

        default:
          // This will allow inclusion during serialization.
          if (!globalMap.unknownKeyVals) globalMap.unknownKeyVals = [];
          globalMap.unknownKeyVals.push(keyVal);
      }
    } // Get input and output counts to loop the respective fields

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var inputCount = inputKeyVals.length;
  var outputCount = outputKeyVals.length;
  var inputs = [];
  var outputs = []; // Get input fields

  var _iterator4 = _createForOfIteratorHelper(tools_1.range(inputCount)),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var index = _step4.value;
      var input = {};

      var _iterator6 = _createForOfIteratorHelper(inputKeyVals[index]),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _keyVal3 = _step6.value;
          convert.inputs.checkPubkey(_keyVal3);

          switch (_keyVal3.key[0]) {
            case typeFields_1.InputTypes.NON_WITNESS_UTXO:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.NON_WITNESS_UTXO);

              if (input.nonWitnessUtxo !== undefined || input.witnessUtxo !== undefined) {
                throw new Error('Format Error: Input has multiple [NON_]WITNESS_UTXO');
              }

              input.nonWitnessUtxo = convert.inputs.nonWitnessUtxo.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.WITNESS_UTXO:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.WITNESS_UTXO);

              if (input.nonWitnessUtxo !== undefined || input.witnessUtxo !== undefined) {
                throw new Error('Format Error: Input has multiple [NON_]WITNESS_UTXO');
              }

              input.witnessUtxo = convert.inputs.witnessUtxo.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.PARTIAL_SIG:
              if (input.partialSig === undefined) {
                input.partialSig = [];
              }

              input.partialSig.push(convert.inputs.partialSig.decode(_keyVal3));
              break;

            case typeFields_1.InputTypes.SIGHASH_TYPE:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.SIGHASH_TYPE);

              if (input.sighashType !== undefined) {
                throw new Error('Format Error: Input has multiple SIGHASH_TYPE');
              }

              input.sighashType = convert.inputs.sighashType.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.REDEEM_SCRIPT:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.REDEEM_SCRIPT);

              if (input.redeemScript !== undefined) {
                throw new Error('Format Error: Input has multiple REDEEM_SCRIPT');
              }

              input.redeemScript = convert.inputs.redeemScript.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.WITNESS_SCRIPT:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.WITNESS_SCRIPT);

              if (input.witnessScript !== undefined) {
                throw new Error('Format Error: Input has multiple WITNESS_SCRIPT');
              }

              input.witnessScript = convert.inputs.witnessScript.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.BIP32_DERIVATION:
              if (input.bip32Derivation === undefined) {
                input.bip32Derivation = [];
              }

              input.bip32Derivation.push(convert.inputs.bip32Derivation.decode(_keyVal3));
              break;

            case typeFields_1.InputTypes.FINAL_SCRIPTSIG:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.FINAL_SCRIPTSIG);
              input.finalScriptSig = convert.inputs.finalScriptSig.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.FINAL_SCRIPTWITNESS:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.FINAL_SCRIPTWITNESS);
              input.finalScriptWitness = convert.inputs.finalScriptWitness.decode(_keyVal3);
              break;

            case typeFields_1.InputTypes.POR_COMMITMENT:
              checkKeyBuffer('input', _keyVal3.key, typeFields_1.InputTypes.POR_COMMITMENT);
              input.porCommitment = convert.inputs.porCommitment.decode(_keyVal3);
              break;

            default:
              // This will allow inclusion during serialization.
              if (!input.unknownKeyVals) input.unknownKeyVals = [];
              input.unknownKeyVals.push(_keyVal3);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      inputs.push(input);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  var _iterator5 = _createForOfIteratorHelper(tools_1.range(outputCount)),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _index2 = _step5.value;
      var output = {};

      var _iterator7 = _createForOfIteratorHelper(outputKeyVals[_index2]),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _keyVal4 = _step7.value;
          convert.outputs.checkPubkey(_keyVal4);

          switch (_keyVal4.key[0]) {
            case typeFields_1.OutputTypes.REDEEM_SCRIPT:
              checkKeyBuffer('output', _keyVal4.key, typeFields_1.OutputTypes.REDEEM_SCRIPT);

              if (output.redeemScript !== undefined) {
                throw new Error('Format Error: Output has multiple REDEEM_SCRIPT');
              }

              output.redeemScript = convert.outputs.redeemScript.decode(_keyVal4);
              break;

            case typeFields_1.OutputTypes.WITNESS_SCRIPT:
              checkKeyBuffer('output', _keyVal4.key, typeFields_1.OutputTypes.WITNESS_SCRIPT);

              if (output.witnessScript !== undefined) {
                throw new Error('Format Error: Output has multiple WITNESS_SCRIPT');
              }

              output.witnessScript = convert.outputs.witnessScript.decode(_keyVal4);
              break;

            case typeFields_1.OutputTypes.BIP32_DERIVATION:
              if (output.bip32Derivation === undefined) {
                output.bip32Derivation = [];
              }

              output.bip32Derivation.push(convert.outputs.bip32Derivation.decode(_keyVal4));
              break;

            default:
              if (!output.unknownKeyVals) output.unknownKeyVals = [];
              output.unknownKeyVals.push(_keyVal4);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      outputs.push(output);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return {
    globalMap: globalMap,
    inputs: inputs,
    outputs: outputs
  };
}

exports.psbtFromKeyVals = psbtFromKeyVals;